'use client';

import { useEffect } from 'react';
import { initFaro } from '@/lib/observability/faro';

export function FaroInit() {
  useEffect(() => {
    initFaro();
  }, []);

  return null;
}
